/**
 * Конфигурация документов для проекта "ОЧКИ"
 * 
 * Этот файл содержит все пути к документам, используемым в приложении.
 * Использование констант обеспечивает:
 * 1. Централизованное управление путями к документам
 * 2. Типобезопасность при использовании TypeScript
 * 3. Легкое обновление путей при изменении структуры хранения
 * 4. Автодополнение в IDE
 */

export const DOCUMENTS = {
  // Сборники заданий по годам
  TASK_COLLECTIONS: {
    YEAR_2025: "/documents/2025/tasks_otbor_2025.pdf",
    YEAR_2024: "/documents/2024/tasks_otbor_2024.pdf",
    YEAR_2023: "/documents/2023/tasks_otbor_2023.pdf",
    // YEAR_2022: "/documents/2022/", // Директория пуста, поэтому закомментировано
  },
  
  // Положения и регламенты
  REGULATIONS: {
    // TODO: Добавить пути к файлам положений, когда они будут загружены
    // MAIN: "/documents/regulation/положение-очки-2026.pdf",
    // PARTICIPATION: "/documents/regulation/регламент-участия.docx",
    POLOZHENIE_2026_2027: "/documents/regulation/polozhenie_2026-2027.pdf",
  },
  
  // Инструкции и методические материалы
  INSTRUCTIONS: {
    // TODO: Добавить пути к инструкциям, когда они будут загружены
    // REGISTRATION: "/documents/instructions/инструкция-регистрации.pdf",
    // PARTICIPANT_GUIDE: "/documents/instructions/руководство-участника.docx",
  },
  
  // Шаблоны документов
  TEMPLATES: {
    // TODO: Добавить пути к шаблонам, когда они будут загружены
    // APPLICATION: "/documents/templates/заявка-участника.docx",
  },
} as const;

// Типы для TypeScript
export type DocumentCategory = keyof typeof DOCUMENTS;
export type DocumentKey = {
  [K in DocumentCategory]: keyof typeof DOCUMENTS[K];
}[DocumentCategory];

/**
 * Вспомогательная функция для получения пути к документу
 * @param category Категория документа (например, "TASK_COLLECTIONS")
 * @param key Ключ документа (например, "YEAR_2024")
 * @returns Путь к документу
 */
export function getDocumentPath(category: DocumentCategory, key: string): string {
  const categoryDocs = DOCUMENTS[category] as Record<string, string>;
  return categoryDocs[key] || "";
}

/**
 * Вспомогательная функция для получения всех документов в категории
 * @param category Категория документа
 * @returns Объект с документами категории
 */
export function getDocumentsByCategory(category: DocumentCategory): Record<string, string> {
  return DOCUMENTS[category] as Record<string, string>;
}

/**
 * Вспомогательная функция для получения всех документов
 * @returns Плоский объект со всеми документами
 */
export function getAllDocuments(): Record<string, string> {
  const allDocs: Record<string, string> = {};
  
  Object.entries(DOCUMENTS).forEach(([category, docs]) => {
    Object.entries(docs as Record<string, string>).forEach(([key, path]) => {
      allDocs[`${category}.${key}`] = path;
    });
  });
  
  return allDocs;
}

// Экспорт по умолчанию для удобства импорта
export default DOCUMENTS;